import { joinURL } from 'ufo';
import { getEnv } from '~/env';

export type AssetToken = {
  chainId: number;
  address?: string;
  name: string;
  symbol: string;
  decimals: number;
  logoURI: string;
};

export type Network = {
  chainId: number;
  chainName: string;
  rpcUrls: Array<string>;
  iconUrls: Array<string>;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  blockExplorerUrls: Array<string>;
  blockExplorerApiUrls: Array<string>;
};

export const fetchAssetTokens = async (): Promise<AssetToken[]> => {
  const response = await fetch(
    joinURL(getEnv('NEXT_PUBLIC_JOC_RESOURCE_BASE_URL') || '', 'tokens', 'index.json'),
  );
  const data = await response.json();
  return data.tokens;
};

export const fetchNetworks = async (): Promise<Network[]> => {
  const response = await fetch(
    joinURL(getEnv('NEXT_PUBLIC_JOC_RESOURCE_BASE_URL') || '', 'networks', 'index.json'),
  );
  const data = await response.json();
  return data.networks;
};
